// extracted by mini-css-extract-plugin
export default {"inputDescription":"auth-code-input_inputDescription__Z9dxJ","footerButtons":"auth-code-input_footerButtons__0RIEW"};